var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.308,
    height: 45,
    viewBox: "0 0 135.308 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ANSRLogos_Rise_Black_160_x_45",
    "data-name": "ANSRLogos_Rise Black 160 x 45",
    transform: "translate(-91.498 -56.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13996",
    "data-name": "Group 13996",
    transform: "translate(97.019 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M160.216,56.5q.226,0,.148.2a12.727,12.727,0,0,0-1.183,1.479,8.73,8.73,0,0,1-7.048,5.668q-2.316.1-4.633,0A22.4,22.4,0,0,1,160.216,56.5Z",
    transform: "translate(-147.5 -56.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.963
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13997",
    "data-name": "Group 13997",
    transform: "translate(92.78 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M128.255,56.5a19.748,19.748,0,0,1,11.828,4.978l-11.434.1a8.563,8.563,0,0,0-5.963,3.4,27.122,27.122,0,0,1-1.971,3.253,8.674,8.674,0,0,1-5.865,3.006q-5.175.074-10.35.049a19.542,19.542,0,0,1,2.366-5.027q4.238-.123,8.477-.148a8.647,8.647,0,0,0,5.963-3.894A8.967,8.967,0,0,1,128.255,56.5Z",
    transform: "translate(-104.5 -56.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.973
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13998",
    "data-name": "Group 13998",
    transform: "translate(91.498 63.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M118.9,130.444q5.964-.025,11.927.049a22.88,22.88,0,0,1,3.253,4.978q-8.087.078-16.165.246a8.377,8.377,0,0,0-5.076,3.3,27.122,27.122,0,0,1-1.971,3.253,8.9,8.9,0,0,1-5.372,2.908q-7,.074-14,.049a20.451,20.451,0,0,1,.591-4.978l13.011-.1a8.571,8.571,0,0,0,6.358-3.894A8.916,8.916,0,0,1,118.9,130.444Z",
    transform: "translate(-91.498 -130.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.979
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13999",
    "data-name": "Group 13999",
    transform: "translate(177.642 64.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M950.136,134.016q3.977-.484,3.4,3.45a2.637,2.637,0,1,1-3.4-3.45Z",
    transform: "translate(-948.456 -133.963)",
    fill: "#0e0f0e",
    fillRule: "evenodd",
    opacity: 0.966
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14000",
    "data-name": "Group 14000",
    transform: "translate(152.788 65.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M699.5,147.444q4.978-.025,9.956.049a11.382,11.382,0,0,1,6.506,2.169,7.743,7.743,0,0,1,2.366,5.964,7.442,7.442,0,0,1-3.549,6.653l-1.873,1.035,7.886,12.321a37.33,37.33,0,0,1-5.421,0l-6.6-11.04q-2.265-.148-4.534-.1v11.237H699.5Zm4.731,3.943q2.468-.043,4.929.148,4.946.559,4.189,5.471a3.808,3.808,0,0,1-3.006,3.2,9.38,9.38,0,0,1-1.676.3q-2.217.074-4.436.049Z",
    transform: "translate(-699.5 -147.437)",
    fill: "#0e0f0e",
    fillRule: "evenodd",
    opacity: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14001",
    "data-name": "Group 14001",
    transform: "translate(91.597 71.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M121.282,205.444q7.344-.025,14.687.049a19.254,19.254,0,0,1,1.084,4.978q-7.689-.025-15.377.049a8.643,8.643,0,0,0-6.062,3.5,27.123,27.123,0,0,1-1.971,3.253,8.67,8.67,0,0,1-5.668,2.908q-7.2.074-14.391.049A33.327,33.327,0,0,1,92.5,215.3q7.343-.123,14.687-.148a8.568,8.568,0,0,0,7.048-3.894A9.235,9.235,0,0,1,121.282,205.444Z",
    transform: "translate(-92.5 -205.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14002",
    "data-name": "Group 14002",
    transform: "translate(187.968 72.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11284",
    "data-name": "Path 11284",
    d: "M1056.195,213.066a18.264,18.264,0,0,1,8.773,1.528,34.114,34.114,0,0,1-1.626,3.5,15.307,15.307,0,0,0-5.766-1.38,5.091,5.091,0,0,0-2.76.542,1.755,1.755,0,0,0-.1,2.859,8.821,8.821,0,0,0,1.873,1.084l4.534,1.873q5.586,2.411,3.7,8.231a5.717,5.717,0,0,1-3.2,3.1,12.46,12.46,0,0,1-3.351.789,21.518,21.518,0,0,1-7.2-.591,10.45,10.45,0,0,1-1.528-.641q-.1-2.021,0-4.041a15.2,15.2,0,0,0,8.822,1.626q2.688-.465,2.218-3.1a2.56,2.56,0,0,0-.739-.936,26,26,0,0,0-5.421-2.563,10.578,10.578,0,0,1-3.992-2.711,6.4,6.4,0,0,1-.591-5.421,6.274,6.274,0,0,1,4.485-3.4Z",
    transform: "translate(-1049.491 -213.019)",
    fill: "#0e0f0e",
    fillRule: "evenodd",
    opacity: 0.975
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14003",
    "data-name": "Group 14003",
    transform: "translate(207.765 72.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11285",
    "data-name": "Path 11285",
    d: "M1253.875,212.94a11.463,11.463,0,0,1,6.308,1.134,8.881,8.881,0,0,1,4.189,7.442q.074,1.773.049,3.549-7.147-.049-14.293.1a7.126,7.126,0,0,0,2.169,5.076,6.669,6.669,0,0,0,4.14,1.232,15.941,15.941,0,0,0,6.8-1.577,18.819,18.819,0,0,1,0,3.844,14,14,0,0,1-4.14,1.232,32.764,32.764,0,0,1-4.732.1q-7.622-1.018-8.822-8.625a16.409,16.409,0,0,1,.789-7.787A8.935,8.935,0,0,1,1253.875,212.94Zm.493,3.549a4.466,4.466,0,0,1,5.274,3.45q.122.841.246,1.676-4.83.2-9.66,0a7.544,7.544,0,0,1,1.331-3.549A5.25,5.25,0,0,1,1254.367,216.488Z",
    transform: "translate(-1245.386 -212.879)",
    fill: "#0e0f0e",
    fillRule: "evenodd",
    opacity: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14004",
    "data-name": "Group 14004",
    transform: "translate(177.941 72.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M951.5,217.5h4.633v21.39H951.5Z",
    transform: "translate(-951.5 -217.5)",
    fill: "#0e0f0e",
    fillRule: "evenodd",
    opacity: 0.984
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14005",
    "data-name": "Group 14005",
    transform: "translate(93.766 79.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M143.578,279.5h13.406a21.823,21.823,0,0,1-.493,5.126q-6.7-.025-13.406.049a8.534,8.534,0,0,0-5.964,3.795,9.759,9.759,0,0,1-3.7,4.584,8.818,8.818,0,0,1-3.253,1.183q-6.259.1-12.518,0a18.785,18.785,0,0,1-3.154-4.978q7.639.025,15.278-.049a8.346,8.346,0,0,0,5.668-3.1,20.615,20.615,0,0,0,1.676-2.859A9.046,9.046,0,0,1,143.578,279.5Z",
    transform: "translate(-114.5 -279.5)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.977
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14006",
    "data-name": "Group 14006",
    transform: "translate(99.384 86.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M196.438,354.387q5.373-.049,10.744.1a20.027,20.027,0,0,1-2.464,4.879l-7.886.1a8.561,8.561,0,0,0-6.456,3.893,9.57,9.57,0,0,1-3.6,4.485,8.749,8.749,0,0,1-4.189,1.331A21.819,21.819,0,0,1,171.5,364.2l11.04-.1a8.663,8.663,0,0,0,6.161-3.1q1.011-1.528,1.873-3.154A8.93,8.93,0,0,1,196.438,354.387Z",
    transform: "translate(-171.5 -354.375)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14007",
    "data-name": "Group 14007",
    transform: "translate(118.372 94.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M367.568,428.444q1.972-.025,3.943.049a21,21,0,0,1-13.011,7.294,9.939,9.939,0,0,0,1.331-1.626A8.806,8.806,0,0,1,367.568,428.444Z",
    transform: "translate(-358.5 -428.437)",
    fill: "#fe5400",
    fillRule: "evenodd",
    opacity: 0.96
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8ce85161b7b73a000e6b2d36a166abce.svg";
export { ForwardRef as ReactComponent };